<template>
  <el-container class="height100">
    <el-header class="obpm-header-t">
      <admin_header />
    </el-header>
    <el-main class="superadmin-list">
      <el-row class="obpm-content-title">{{$t('platform')}}</el-row>
      <el-row class="obpm-nav-item" sytle="text-align:center;" type="flex" justify="center">
        <el-col :span="3">
          <router-link to="/main" class="obpm-enterprise-domain">
            <span></span>
            <p>{{$t('enterprise_domain')}}</p>
          </router-link>
        </el-col>
        <el-col :span="3">
          <router-link to="/superuser" class="obpm-privileged-user">
            <span></span>
            <p>{{$t('superuser')}}</p>
          </router-link>
        </el-col>
        <el-col :span="3" v-if="(isOpen && isAdmin && !isAdminDomain) ||(isOpen && isSecret && !isSecretDomain)|| !isOpen">
          <router-link to="/systemCon" class="obpm-system">
            <span></span>
            <p>{{$t('systemCon')}}</p>
          </router-link>
        </el-col>
        <el-col :span="3"  v-if="(isOpen && isAdmin && !isAdminDomain) || !isOpen">
          <router-link to="/systemMoni" class="obpm-systemMoni">
            <span></span>
            <p>{{$t('systemMoni')}}</p>
          </router-link>
        </el-col>
        
        <el-col :span="3" v-if="(isOpen && isAdmin && !isAdminDomain) || !isOpen">
          <a tabindex :href="$api.getDebugUrl('/login/debuglogin.html')" class="obpm-debugmode" target="_blank">
            <span></span>
            <p>{{$t('debugmode')}}</p>
          </a>
        </el-col>
      </el-row>
    </el-main>
    <el-footer class="obpm-footer">
      <!-- 平台运营与技术支持 © 百川信   备案证书号：闽ICP备14018517号-3 -->
      </el-footer>
  </el-container>
</template>

<script>
import admin_header from "@/components/admin_header.vue";
export default {
  components: {
    admin_header,
  },
  data() {
    return {
      isOpen:false,//开关是否开启
      isAdmin:false,//是否是系统管理员
      isAdminDomain:false,//是否是域级系统管理员
      isSecret:false,//是否是安全保密员
      isSecretDomain:false,//是否是域级安全保密员
    };
  },
  created(){
    if(this.$store.state.currentUser.isOpenSecurity){
      this.isOpen=true;
      if(this.$store.state.currentUser.type=='admin'){
        this.isAdmin=true;
        if(this.$store.state.currentUser.departments.length<=0 && this.$store.state.currentUser.domains.length>0) {
          this.isAdminDomain=true;
        }
      }else if(this.$store.state.currentUser.type=="secret"){
        this.isSecret=true;
        if(this.$store.state.currentUser.departments.length<=0 && this.$store.state.currentUser.domains.length>0) {
          this.isSecretDomain=true;
        }
      }else if(this.$store.state.currentUser.type=="secret"){
        this.isSecret=true;
        if(this.$store.state.currentUser.departments.length<=0 && this.$store.state.currentUser.domains.length>0) {
          this.isSecretDomain=true;
        }
      }

    }else{
      this.isOpen=false;

    }
  },
  methods: {
  }
};
</script>
<style lang="scss" scoped>
.superadmin-list{
  text-align:center;
  padding-top:80px;
}
.obpm-content-title{
  font-size:18px;
  padding-bottom:30px;
}
.obpm-nav-item a{
  text-decoration: none;
  font-size: 14px;
  color: #666666;
}
.obpm-nav-item a:hover{
  color: #59a8ff;
}
.obpm-enterprise-domain span,.obpm-privileged-user span,.obpm-system span,.obpm-systemMoni span,.obpm-debugmode span{
  width: 150px;
  height: 150px;
  border-radius: 50%;
  display: inline-block;
}
.obpm-enterprise-domain span{
  background: url('../assets/images/index_domain.png') no-repeat;
}
.obpm-enterprise-domain:hover span{
  background: url('../assets/images/index_domain_c.png') no-repeat;
}
.obpm-privileged-user span{
  background: url('../assets/images/index_superuser.png') no-repeat;
}
.obpm-privileged-user:hover span{
  background: url('../assets/images/index_superuser_c.png') no-repeat;
}
.obpm-system span{
  background: url('../assets/images/index_systemconfiguration.png') no-repeat;
}
.obpm-system:hover span{
  background: url('../assets/images/index_systemconfiguration_c.png') no-repeat;
}
.obpm-systemMoni span{
  background: url('../assets/images/index_systemmonitor.png') no-repeat;
}
.obpm-systemMoni:hover span{
  background: url('../assets/images/index_systemmonitor_c.png') no-repeat;
}
.obpm-debugmode span{
  background: url('../assets/images/index_debugmode.png') no-repeat;
}
.obpm-debugmode:hover span{
  background: url('../assets/images/index_debugmode_c.png') no-repeat;
}
.obpm-footer{
  text-align: center;
  font-size: 12px;
  color: #666666;
}
</style>
